module.exports = __webpack_public_path__ + "static/media/kaustubh.c373d44d.png";